export default __webpack_public_path__ + "static/media/SIFA_FR_SEQ07.fdc478f6.mp3";